import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgObstacle = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	"data-name": "Layer 1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 19.63 18.4",
	fill: "inherit",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", {}), /* @__PURE__ */ _jsx("path", { d: "M9.82,11.33c2.44,0,4.49-.83,4.61-1.92-.36-1.02-.76-2.13-1.15-3.22-.27.78-1.76,1.33-3.46,1.33s-3.19-.55-3.46-1.33c-.39,1.09-.79,2.2-1.15,3.22.12,1.09,2.17,1.92,4.61,1.92ZM9.82,4.47c1.15,0,2.22-.36,2.53-.91-.43-1.21-.8-2.25-1.03-2.9-.16-.44-.86-.66-1.49-.66s-1.34.23-1.49.66c-.23.65-.6,1.69-1.03,2.9.31.55,1.38.91,2.53.91ZM18.79,12.34l-3.84-1.55.44,1.23c-.02,1.31-2.56,2.35-5.58,2.35s-5.56-1.04-5.58-2.35l.44-1.23-3.84,1.55c-1.08.43-1.12,1.24-.1,1.78l7.22,3.87c1.02.55,2.69.55,3.71,0l7.22-3.87c1.02-.55.98-1.35-.1-1.78Z" })]
});
export default SvgObstacle;
